import { faPlus, faCheckCircle, faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useAppContext } from '../context/AppContext';
import Button from '@mui/joy/Button';
import Row from './Row';
import Typography from '@mui/joy/Typography';
import './TagSearchResults.css';
import { useState } from 'react';

// eslint-disable-next-line react/prop-types
const SearchResultRow = ({ tag, onAddToCart, isInCart }) => {
    const [didClickAdd, setDidClickAdd] = useState(false);

    function handleAddToCart(tag) {
        setDidClickAdd(true);
        onAddToCart(tag);
        setTimeout(() => setDidClickAdd(false), 3000);
    }

    return (
        <Row
            alignItems="center"
            justifyContent="space-between"
            className="search-result-row"
        >
            <Typography><strong>&{tag.text}</strong></Typography>
            <Row alignItems="center">
                {
                    tag.price ? (
                        <>
                            <Typography><span style={{ fontWeight: 500 }}>{tag.price}</span></Typography>
                            <Button
                                onClick={() => handleAddToCart(tag)}
                                disabled={isInCart || didClickAdd}
                            >
                                {isInCart ?
                                    <FontAwesomeIcon icon={faCheckCircle} color={'#71BEB4'} /> :
                                    <FontAwesomeIcon icon={faPlus} />
                                }
                            </Button>
                        </>
                    )
                        :
                        <FontAwesomeIcon icon={faSpinner} spin />
                }
            </Row>
        </Row>
    );
};

// Component used to render a search results when the tag
// directly matches the andee's search input text 
const SearchResultDirectMatchRow = (props) => {
    const { tag, onAddToCart, isInCart } = props;
    const className = tag.isNotForSale ? 'search-result-row--private' : 'search-result-row--match';
    const [didClickAdd, setDidClickAdd] = useState(false);

    function handleAddToCart(tag) {
        setDidClickAdd(true);
        onAddToCart(tag);
        setTimeout(() => setDidClickAdd(false), 3000);
    }

    return (
        <Row
            alignItems="center"
            justifyContent="space-between"
            className={'search-result-row ' + className}
        >
            <span><strong>&{tag.text}</strong> is {tag.isNotForSale ? 'taken' : 'available!'}</span>
            <Row alignItems="center" gap={20}>
                <span style={{ fontWeight: 500 }}>{tag.isNotForSale ? 'Accepting offers soon' : tag.price}</span>
                <Button
                    onClick={() => handleAddToCart(tag)}
                    disabled={isInCart || didClickAdd}
                    style={{ display: tag.isNotForSale ? 'none' : 'block' }}
                >
                    {isInCart ?
                        <Row alignItems="center" justifyContent="center">
                            <FontAwesomeIcon icon={faCheckCircle} color={'#71BEB4'} />
                            <span>Added</span>
                        </Row> :
                        <span>Add to Cart</span>
                    }
                </Button>
            </Row>
        </Row>
    );
};

const TagSearchResults = (props) => {
    const { results = [], onAddToCart } = props;
    const { cart } = useAppContext();
    const tagIsInCart = (tag) => {
        return cart.tags?.some(t => t.text === tag.text);
    };

    const renderTagRow = (tag) => {
        // TODO: add to local tag type
        if (tag.isDirectMatch) {
            return (
                <SearchResultDirectMatchRow
                    key={tag.text}
                    tag={tag}
                    onAddToCart={onAddToCart}
                    isInCart={tagIsInCart(tag)}
                />
            );
        }

        return (
            <SearchResultRow
                key={tag.text}
                tag={tag}
                onAddToCart={onAddToCart}
                isInCart={tagIsInCart(tag)}
            />
        );
    };

    // I'm not sure this is actually possible
    if (results.length === 0) {
        return (
            <div className="search-results" style={{ border: 'none' }}>
                <Typography>No &tags found. Please try a new search.</Typography>
            </div>);
    }

    return (
        <div className="search-results">
            {results.map(renderTagRow)}
        </div>
    );
};

export default TagSearchResults;
